import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import QueryParams from 'utils/queryParams';
import { API_ONEPLATFORM_TASKS } from 'services/dataService/resources/oneplatform/constants';
import { DEFAULT_PAGE_LIMIT, QUERY_KEYS } from 'pages/TasksDashboard/constants';

interface ITasksBadgeResponse {
  navBadgeCount: number;
}

export const useTasksBadge = ({ enabled = true }: { enabled?: boolean }) => {
  const { data } = useQuery({
    queryKey: [QUERY_KEYS.tasksBadgeCount],
    queryFn: async () => {
      const url = QueryParams.stringifyUrl(API_ONEPLATFORM_TASKS, {
        tab: 'open_pool',
        limit: DEFAULT_PAGE_LIMIT,
        offset: 0,
      });
      const response = await dataService.getList<ITasksBadgeResponse>(url);
      if (response.error) throw new Error(response.error);
      return response.data;
    },
    refetchInterval: 30000,
    staleTime: 15000,
    refetchIntervalInBackground: false,
    retry: 2,
    enabled,
  });

  return {
    tasksBadgeCount: data?.navBadgeCount ?? 0,
  };
};
